import axios from "axios";
import Dropzone from "react-dropzone-uploader"
import 'react-dropzone-uploader/dist/styles.css'

import { get_media } from "../../../../api/api";
import { mediaUpload } from './../../../../api/api';

const UploadPoster = ({ havePoster, pullback, setLoading }) => {

     const getUploadParams = async ({ file, meta }) => {
          const formData = new FormData();
          formData.append("file", file);

          try {
               setLoading(true)
               const res = await axios.post(mediaUpload, formData);
               pullback(res.data.mediaId)
               return true
          } catch (err) {
               return false
          } finally {
               setLoading(false)
          }


     }

     const removeImage = () => {
          pullback(false)
          document.getElementById('defImage').remove()
     }

     return (
          <div className="dpHolder">
               {havePoster && (

                    <div className="dzu-dropzone" id='defImage'>
                         <div className="dzu-previewContainer">
                              <img className="dzu-previewImage" src={get_media(havePoster)} /><div className="dzu-previewStatusContainer">
                                   <span onClick={removeImage} className="dzu-previewButton" style={{ backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUuMCwgMC4wKSIgZmlsbD0iIzMzMzMzMyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4wLCAwLjApIj48cG9seWdvbiBwb2ludHM9IjcuNzE5IDQuOTY0IDEyLjY5MiAwLjAxNyAxNC4zODkgMS43MTUgOS40MTIgNi42NjYgMTQuMzU0IDExLjYzNCAxMi42NTcgMTMuMzMxIDYuMDE3IDYuNjU3IDcuNzE1IDQuOTYwIj48L3BvbHlnb24+PHBvbHlnb24gcG9pbnRzPSI3LjYxMiA0Ljk2NCA3LjYxNiA0Ljk2MCA5LjMxMyA2LjY1NyAyLjY3NCAxMy4zMzEgMC45NzcgMTEuNjM0IDUuOTE5IDYuNjY2IDAuOTQyIDEuNzE1IDIuNjM5IDAuMDE3Ij48L3BvbHlnb24+PC9nPjwvZz48L3N2Zz4K)' }}></span>
                              </div>
                         </div>
                    </div>
               )}


               <Dropzone
                    getUploadParams={getUploadParams}
                    maxFiles={1}
                    multiple={false}
                    canCancel={true}
                    inputContent="تصویر شاخص"
                    accept="image/png,image/jpg,image/jpeg"
               />
          </div>
     )
}
export default UploadPoster